import { useState } from 'react';
import { getParameterByView, updateUserParameters } from './storageMemoHelper';
export function useAnimationMemo(view_type) {
    const [data, setData] = useState(getParameterByView(view_type));
    const [animationMemo, setAnimationMemo] = useState(data === true || data == null ? "" : "hide_memo");
    const [rotateChevron, setRotateChevron] = useState(data != null ? !data : false);

    const openMemo = async () => {
        updateUserParameters(view_type, rotateChevron)

        setRotateChevron(!rotateChevron);
        let css = !rotateChevron ? "hide_memo" : ""
        setAnimationMemo(css)
    }

    return { animationMemo, openMemo, rotateChevron }
}